import cabri from "../app/cabri-app";
import {GeomObject} from "./geom-object";
import * as BABYLON from "babylonjs/babylon.max";

class Point extends GeomObject {
    constructor (x, y, z) {
        if (arguments.length === 3) {
            if(cabri.testRunning)
                super(0);
            else
                super(window.cabri.emsc.createPoint3(x, y, z));

            this.point_size = 1;
            this.point_color = "#0000FF";
            this.bPoint = null;
            if(!cabri.testRunning)
                window.cabri.emsc.setAffineCoordinates(this.objectId, x, y, z);
            this.forceUpdateInNextCycle = true;
        }
        else
            if (arguments.length === 1) {
                super(x);
                this.point_size =
                    super.getFloatStyleAttribute("point_size", 1.0);
                this.point_color =
                    super.getColorAttribute("point_color", "#0000FF");
                this.bPoint = null;
            }
    }

    move (x, y, z) {
        if (x !== this.x || y !== this.y || z !== this.z) {
            cabri.notifyFileDirty();
            window.cabri.emsc.setAffineCoordinates(this.objectId, x, y, z);
        }
    }

    // methods only to be called after all properties are defined

    getMaterial () {
        return this.bPoint.material;
    }

    createSphere () {
        if (this.noDisplay || this.hidden) return;
        if (this.bPoint === null) {
            this.bPoint =
                BABYLON.MeshBuilder.CreateSphere("freePoint" + this.objectId,
                    {
                        diameter: 0.15 * this.point_size * 2,  // TODO to be adjusted...
                        segments: 8,        // default is 32
                    },
                    cabri.scene);
            //this.bPoint.isVisible = false;
            this.bPoint.cabriPeer = this;
            super.markColor(this.bPoint, this.point_color);
            let extraListener = null;
            if(cabri.emsc.getControllingRelationClass(this.objectId).startsWith("free_point_")) {
                // free point... make this a priority movable object
                const thePoint = this;
                extraListener = function(isHighlighted) {
                    const f = cabri.highlightedPoints.indexOf(thePoint);
                    if(isHighlighted) {
                        if(f===-1) cabri.highlightedPoints.push(thePoint)
                    } else {
                        cabri.highlightedPoints.splice(f,1);
                    }
                }
                super.registerHighlighter(this.bPoint,
                    new BABYLON.Color3(0.4, 0.1, 0.1), null, extraListener);
            }


        }
    }

    updateFromPeer () {
        if (typeof (this.objectId) === "undefined") return;
        if (this.alreadyCheckedInLastCycle) return this.updatedInLastCycle;
        this.alreadyCheckedInLastCycle = true;
        let coords = null;
        try {
            coords = window.cabri.emsc.getAffineCoordinates(this.objectId);
            if (this.forceUpdateInNextCycle || coords !== null &&
                (coords[0] !==  this.x || coords[1] !== this.y || coords[2] !== this.z)) {
                this.x = coords[0];
                this.y = coords[1];
                this.z = coords[2];
                if (this.bPoint === null) {
                    this.createSphere();
                }
                if (this.bPoint !== null) {
                    this.bPoint.position =
                        new BABYLON.Vector3(this.x, this.z, this.y);
                }
            }
        } catch (e) {
            console.log(
                "Trouble at updateFromPeer (" + this.constructor.name + ").");
            console.log(e);
        } finally {
            if (coords) try {
                cabri.emsc._free(coords);
            } catch (e) {
            }
        }
        this.updatedInLastCycle = true;
        return this.updatedInLastCycle;
    }

    getObjectId () {
        return this.objectId;
    }

    dragAlongRay (ray, pickpoint, verticalMode) {
        if (this.noPicking) return;
        // make the ray a pick vector
        const d = ray.direction, o = ray.origin,
            p = pickpoint ? pickpoint : {x: this.x, y: this.z, z: this.y};
        if (p.x === undefined || p.y === undefined || p.z === undefined ||
            d.x === undefined || d.y === undefined || d.z === undefined) return;

        // int objectId, double u,double v,double t, double x,double y,double z,
        // bool verticalMode,  double clickX, double clickY, double clickZ, bool roundingMode
        cabri.emsc.setFromPickVectorAndMode(this.objectId, d.x, d.z, d.y, o.x,
            o.z, o.y,
            verticalMode, p.x, p.z, p.y, false);
        cabri.emsc.processTasks();
    }

    // =------

    dispose () {
        if (this.bPoint) this.bPoint.dispose(false, true);
        super.dispose();
    }

    getCoords () {
        return [this.x, this.y, this.z];
    }
}



export {Point};